<template>
      <div class="xs-12">
            <!-- Headline -->
            <div slot="headline" class="fs5 lh125 fw7 c1 mb2">{{ $t("actions") }}</div>

            <!-- Body -->
            <j-card class="bg5">
                  <!-- Send Offer -->
                  <div
                        v-if="$store.state.settings.quotes.offers.hasSendOffer"
                        class="flex xs-12 xs-middle xs-between p2 bb1 bc7"
                  >
                        <div class="xs-6 fs3 fw7 c6 lh125">{{ $t("send_offer_to_client") }}</div>
                        <div class="flex xs-6 xs-right">
                              <j-button
                                    size="xsmall"
                                    :isLoading="isSendOfferLoading"
                                    v-tooltip="sendOfferTooltip"
                                    @click="sendOffer"
                                    action="sendOffer"
                              >{{ $t("send") }}</j-button>
                        </div>
                  </div>

                  <!-- Convert to Quote -->
                  <div class="flex xs-12 xs-middle xs-between p2">
                        <div class="fs3 fw7 c6 lh125">{{ $t("accept_offer") }}</div>
                        <j-button
                              :isLoading="isconvertToQuoteLoading"
                              v-tooltip="convertToQuoteTooltip"
                              size="xsmall"
                              @click="convertToQuote"
                              action="acceptOffer"
                        >{{ $t("accept_offer") }}</j-button>
                  </div>
            </j-card>
      </div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import get from "lodash.get"
import api from "../api/"
import dayjs from "dayjs"

// Templates
// TODO: this will be refactored one beautiful day
// we should have better mechanics for those templates than hardcoding in codebase

import { counteroffer } from "@/clientSettings/templates/asia_uat.js"

/**
 * This component is responsible for numerous actions that can happen on offer
 * It's a smart component that is calling APIs
 */
export default {
	components: { JCard, JButton },

	props: {
		policyId: {
			type: String,
			required: true,
			default: ""
		},

		offerId: {
			type: String,
			required: true,
			default: ""
		},

		/**
		 * This prop contains all info we have about offer
		 * TODO: it's bit hacky, doing this for templates
		 */
		context: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},

	data() {
		return {
			isSendOfferLoading: false,
			isconvertToQuoteLoading: false
		}
	},

	computed: {
		sendOfferTooltip() {
			return {
				placement: "auto",
				content: this.$t("send_offer_description"),
				delay: { show: 500 }
			}
		},

		convertToQuoteTooltip() {
			return {
				placement: "auto",
				content: this.$t("accept_offer_description"),
				delay: { show: 500 }
			}
		}
	},

	methods: {
		async sendOffer() {
			this.isSendOfferLoading = true

			// 1: Get all data for quote so that we can populate templates
			const quote = await api.quote({
				where: { id: this.policyId }
			})
			if (quote.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isSendOfferLoading = true
				return
			}

			// 2: Send notification
			//  TODO: massage and populate with data from quote above
			// But some data has to be taken from offer see props we are getting here - e.g. for endorsemenet
			const payload = quote.data.policies.list[0]
			const context = this.context

			const toEmail = payload.holder.contacts
				.filter(item => item.type === "email")
				.map(item => item.value)
				.toString()

			const res = await api.sendNotification({
				input: {
					type: "counteroffer",
					emailMessage: counteroffer({
						toEmail: toEmail,
						payload,
						context,
						type: "quote",
						context: this.context
					})
				}
			})

			this.isSendOfferLoading = false

			// Errros
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Success
			this.$store.dispatch("showSuccess", this.$t("email_was_sent"))
		},

		async convertToQuote(offerId) {
			this.isconvertToQuoteLoading = true

			const res = await api.convertOffer({
				policyId: this.policyId,
				offerId: this.offerId
			})

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isconvertToQuoteLoading = false // remove loading when error
				return
			}

			// Go back to Quote Detail Overview page
			this.$router.push({
				name: "QuoteDetail",
				params: { id: this.policyId }
			})

			// Success
			this.$store.dispatch(
				"showSuccess",
				this.$t("offer_was_converted_to_quote")
			)
			this.isconvertToQuoteLoading = false
		}
	}
}
</script>